import React from "react";
import classNames from "classnames";
import {FaGamepad} from "react-icons/fa6";
import {BsPuzzleFill} from "react-icons/bs";

// Icon ghép cho "Học & Chơi" (đổi tên từ "Góc trò chơi") - GHÉP 2 icon (tay cầm chơi game = Chơi,
// mảnh ghép = Chơi, mảnh ghép TÁI DÙNG đúng icon BsPuzzleFill vốn đã dùng riêng cho mục "games"
// trước đây, không tự chế icon "chơi" khác) thành 1 hình, đè góc dưới-phải - cùng kiểu ghép "icon
// nền lớn + icon phụ nhỏ đè góc" với FamilyIcon/MassTimeTileIcon, đồng nhất phong cách icon
// "2-trong-1" cho các mục nổi bật trong sidebar (Tính năng nổi bật).
// Icon chính TRƯỚC ĐÂY là mũ tốt nghiệp (FaGraduationCap) - đổi sang FaGamepad vì mũ tốt nghiệp giờ
// là icon riêng của Kristo Edu (/edu, RiGraduationCapFill), tránh 2 sub-app trùng icon.
// ĐÃ THỬ kiểu lồng thật (mảnh ghép nằm ngay trên mặt icon chính, không khoanh tròn riêng) - phản hồi
// thực tế "không ổn", quay lại kiểu badge góc này.
export const LearnPlayIcon = ({
                                   size = 32,
                                   capColor = '#7c3aed',      // violet-600 - màu riêng cho "Học & Chơi",
                                   // phân biệt với gia đình (cam, family-600) / nhà thờ (teal-700)
                                   puzzleColor = '#fff',
                                   puzzleBgColor = '#f59e0b', // amber-500 - nền tròn RIÊNG cho icon phụ
                                   // (mảnh ghép trắng nằm ngoài icon chính, trên nền trong suốt dễ
                                   // lẫn vào nền sáng xung quanh - phản hồi thực tế "màu icon phụ" khó
                                   // thấy) - có nền tròn thì LUÔN đủ tương phản bất kể icon đứng trên
                                   // nền gì, không phụ thuộc màu nền trang.
                                   // showBadge: true (mặc định) - tắt khi bị dùng lại ở ngữ cảnh cỡ
                                   // quá khác - xem SectionHeroBanner (SpaceWebApps.js).
                                   showBadge = true,
                                   className,
                                   style,
                                   ...props
                               }) => (
    <div
        style={{width: size, height: size, backgroundColor: 'transparent', ...style}}
        className={classNames('flex-shrink-0 rounded-lg flex items-center justify-center', showBadge ? 'relative' : '', className)}
        {...props}>
        {/* Tay cầm chơi game - giữ cùng tỉ lệ 0.85 lần size đã chỉnh trước đây cho icon chính, khớp
            độ lớn thị giác với FaLocationPin bên MassTimeTileIcon (dùng gần trọn size, không thu nhỏ). */}
        <FaGamepad
            size={size * 0.85}
            style={{color: capColor, filter: 'drop-shadow(0px 1px 1px rgba(0,0,0,0.2))'}}
        />
        {showBadge && (
            <div
                style={{
                    width: size * 0.46,
                    height: size * 0.46,
                    borderRadius: '9999px',
                    backgroundColor: puzzleBgColor,
                    position: 'absolute',
                    bottom: '-4%',
                    right: '-4%',
                    filter: 'drop-shadow(0px 1px 1px rgba(0,0,0,0.25))',
                }}
                className="flex items-center justify-center">
                <BsPuzzleFill size={size * 0.26} style={{color: puzzleColor}}/>
            </div>
        )}
    </div>
);
